import { render, staticRenderFns } from "./VideosPage.vue?vue&type=template&id=4bcbec82&"
import script from "./VideosPage.vue?vue&type=script&lang=ts&"
export * from "./VideosPage.vue?vue&type=script&lang=ts&"
import style0 from "./VideosPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports